import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import Banner, { BannerElement } from "@/components/Banner/Banner";
import {
  MotifButton,
  MotifFormField,
  MotifIcon,
  MotifOption,
  MotifProgressLoader,
  MotifSelect,
  MotifTable,
} from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import { useParams } from "react-router-dom";
import { useColumnImportSummaryDefs } from "./component/ImportSummaryColumnDef";
import {
  useGetImportSummaryHeaderDataQuery,
  useGetReadImportSummaryListDataQuery,
} from "./ImportandExportReducers";
import { useEffect, useMemo, useState } from "react";
import CustomPagination from "@/components/Pagination/CustomPagination";
import { useTranslation } from "react-i18next";
import { MotifChip } from "@/libs/@ey-xd/motif-react/main";
import {
  customPaginationPageSize,
  customPaginationPageSizeSelector,
  customTableLoadingData,
  tableRowHeight,
} from "@/components/Table/CustomPaginationConstants";

import { dateFunc } from "@/components/Functions/dateFunc";
import ErrorMessage from "../Distributions/ManualDataSource/ErrorMessage/ErrorMessage";
import { useLazyExportDocumentQuery } from "@/services/exports/exportsReducer";
import { EXPORT_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { useDispatch, useSelector } from "react-redux";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { getEntitiyTitle } from "./importHelper";
import { ActiveTabsOrder } from "@/menuData";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
export default function ImportSummary() {
  const { caseId, importJobId } = useParams();
  const paginationPageSize = customPaginationPageSize;
  const { caseName } = useSelector((state: any) => state.case);
  const retainState = useSelector(
    (e: any) => e.retainState.importHistoryTabState
  );
  const { t } = useTranslation();
  const columnImportSummaryDefs = useColumnImportSummaryDefs();
  const paginationPageSizeSelector = customPaginationPageSizeSelector;
  let tableLoadingData = customTableLoadingData;

  const filterOptions = [
    {
      value: 2,
      name: t("pages.importHistory.importRecords.successfulRecords"),
    },
    {
      value: 1,
      name: t("pages.importHistory.importRecords.failedRecords"),
    },
  ];
  const dispatch = useDispatch();

  const [exportDocument, { isLoading: importLoading }] =
    useLazyExportDocumentQuery();
  const getPaginationObj: any = useMemo(() => {
    let value: any = {};
    if (retainState.importId === importJobId) {
      value = {
        ImportJobId: importJobId,
        currentPage: retainState?.PageNumber || 1,
        pageSize: retainState?.PageSize || paginationPageSize,
        searchText: retainState?.SearchText || "",
        isStatusFilter: retainState?.isStatusFilter,
        isSuccess: retainState?.isSuccess,
      };
      if (retainState?.SortOrder && retainState?.SortColumn) {
        value.sortOrder = retainState?.SortOrder;
        value.sortColumn = retainState?.SortColumn;
      }
    } else {
      value = {
        ImportJobId: importJobId,
        currentPage: 1,
        pageSize: paginationPageSize,
        searchText: "",
        isStatusFilter: false,
        isSuccess: true,
      };
    }

    return value;
  }, [importJobId, paginationPageSize, retainState]);

  const paginationObj = getPaginationObj;
  const [errorMessage, setErrorMessage] = useState("");
  const { data: HeaderData } = useGetImportSummaryHeaderDataQuery(importJobId);
  const fileStatusJson: any = {
    0: "Queued",
    1: "InProgress",
    2: "Success",
    3: "Failed",
  };
  const { data, isLoading, isFetching, refetch, error, status } =
    useGetReadImportSummaryListDataQuery(paginationObj);
  const headerData = {
    title: t("pages.importHistory.importRecords.tableTitle"),
    description: t("pages.importHistory.importRecords.tableDescription"),
  };
  let datarow = data?.results.length;
  let showFailedScreen =
    HeaderData?.errorMessage &&
    !isFetching &&
    !isLoading &&
    datarow === 0 &&
    paginationObj.currentPage === 1 &&
    !paginationObj.isStatusFilter;
  const bannerElement: BannerElement[] = [
    {
      label: "pages.importHistory.importRecords.bannerDetails.label1",
      value: HeaderData?.fileName ? String(HeaderData.fileName) : "-",
      elementKey: "caseID",
      className: "overFlowWrapAnywhere",
    },
    {
      label: "pages.importHistory.importRecords.bannerDetails.label2",
      value: showFailedScreen ? "Failed" : fileStatusJson[HeaderData?.status],

      elementKey: "caseID",
    },
    {
      label: "pages.importHistory.importRecords.bannerDetails.label5",
      value: HeaderData?.createdBy,
    },
    {
      label: "pages.importHistory.importRecords.bannerDetails.label4",
      value: HeaderData?.createdOn
        ? dateFunc(HeaderData?.createdOn).formattedDateOnly
        : "-",
      elementKey: "caseID",
    },
  ];
  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: caseName,
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.IMPORT}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: HeaderData?.fileName,
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.IMPORT}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled: true,
    },
  ];

  function handlePaginationData(data: any, columnTypesData: any) {
    dispatch(
      setComponentState1({
        entityName: "importHistoryTabState",
        entityState: {
          importId: importJobId,
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }
  function handleMotifSorting(e: any, paginationObj: any) {
    if (e?.source !== "gridOptionsChanged") {
      let sortedColumnsLength: any = e?.columns ? e.columns.length : "";
      if (sortedColumnsLength !== "") {
        let coumnName = e?.columns?.[sortedColumnsLength - 1]?.colId;
        let sortName = e?.columns?.[sortedColumnsLength - 1]?.sort;
        let typeName = e?.columns?.[sortedColumnsLength - 1]?.colDef?.type;
        let paginationJson: any = { ...paginationObj };
        let columnTypesCustom: any = {};
        if (typeName) {
          columnTypesCustom[typeName] = { sort: sortName };
        }
        paginationJson.SortOrder = sortName;
        paginationJson.SortColumn =
          coumnName?.charAt(0)?.toUpperCase() + coumnName?.slice(1);
        if (!sortName) {
          delete paginationJson.SortOrder;
          delete paginationJson.SortColumn;
        }
        if (e?.columns[0]?.colDef?.field) {
          if (handlePaginationData) {
            handlePaginationData(paginationJson, columnTypesCustom);
          }
        }
      }
    }
  }
  let resetSortStatus = () => {
    let json: any = { ...retainState.sortedColumnTypes };
    for (const key in json) {
      json[key] = { sort: null };
    }
    return json;
  };
  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isLoading) {
    return <div> {t("global.globalNotifications.loadingMessage")}</div>;
  }

  function handleTypeOfRecors(e: any) {
    dispatch(
      setComponentState1({
        entityName: "importHistoryTabState",
        entityState: {
          importId: importJobId,
          PageNumber: 1,
          PageSize: paginationPageSize,
          SearchText: "",
          SortOrder: "",
          SortColumn: "",
          isStatusFilter: e ? true : false,
          isSuccess: e === 1 ? false : true,
          sortedColumnTypes: {
            ...resetSortStatus(),
          },
        },
      })
    );
  }

  async function handleExport() {
    setErrorMessage("");
    if (importJobId) {
      await exportDocument({
        importJobId,
        url: "/Import/ExportAllImportJobRecords",
        fileName: HeaderData?.fileName,
      })
        .then((response) => {
          if (response?.error && "data" in response.error) {
            try {
              const errObj = JSON.parse(response?.error?.data as string);
              setErrorMessage(errObj?.message || errObj.title);
            } catch (error) {
              setErrorMessage("Something went wrong!!");
            }
          }
        })
        .catch((error: any) => {
          setErrorMessage("Something went wrong!!");
        });
    }
  }
  return (
    <>
      {caseName && HeaderData?.fileName ? (
        <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
      ) : (
        <MotifProgressLoader variant="default"></MotifProgressLoader>
      )}
      <Banner
        bannerName={"pages.importHistory.importRecords.bannerDetails.label3"}
        bannerNameValue={getEntitiyTitle(HeaderData?.entityType) || "-"}
        elements={bannerElement}
      />
      <div>
        {errorMessage && (
          <div className="pad-t-40">
            <NotificationGrid show={true} type="error" message={errorMessage} />
          </div>
        )}
        {showFailedScreen ? (
          <ErrorMessage
            errorMessage={
              HeaderData?.errorMessage
                ? HeaderData?.errorMessage
                : t("global.globalNotifications.uploadError")
            }
          />
        ) : (
          <div
            className="mar-b-50"
            style={
              data?.results?.length === 0 || !data || isFetching
                ? { marginTop: "50px", height: "180px" }
                : { marginTop: "50px" }
            }
          >
            <MotifTable
              columnTypes={
                retainState.importId === importJobId
                  ? { ...retainState.sortedColumnTypes }
                  : {}
              }
              onSortChanged={(e: any) => {
                handleMotifSorting(e, paginationObj);
              }}
              suppressMultiSort={true}
              defaultColDef={{
                cellStyle: {
                  whiteSpace: "normal",
                  lineHeight: "1.5",
                },
              }}
              rowHeight={tableRowHeight}
              paginateChildRows={true}
              columnDefs={columnImportSummaryDefs}
              rowData={isFetching ? [] : data ? data.results : []}
              titleComplement={
                <div
                  style={{
                    width: "50%",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {paginationObj.isStatusFilter ? (
                    <MotifChip
                      onClick={() => {
                        dispatch(
                          setComponentState1({
                            entityName: "importHistoryTabState",
                            entityState: {
                              importId: importJobId,
                              PageNumber: 1,
                              PageSize: paginationPageSize,
                              SearchText: "",
                              SortOrder: "",
                              SortColumn: "",
                              isStatusFilter: false,
                              isSuccess: true,
                              sortedColumnTypes: {
                                ...resetSortStatus(),
                              },
                            },
                          })
                        );
                      }}
                      title="Reset Filter"
                      variant="monochrome-dark"
                    >
                      {t("pages.importHistory.importRecords.resetFilter")}
                    </MotifChip>
                  ) : (
                    <></>
                  )}

                  <MotifFormField
                    className="motif-col-md-5"
                    style={{ paddingRight: "10px" }}
                  >
                    <MotifSelect
                      placeholder={t(
                        "pages.importHistory.importRecords.statusFilter"
                      )}
                      visibleOptions={3}
                      onChange={(e) => handleTypeOfRecors(e)}
                      value={
                        paginationObj.isStatusFilter
                          ? paginationObj.isSuccess
                            ? 2
                            : 1
                          : ""
                      }
                      triggerButtonProps={{ type: "button" }}
                    >
                      {filterOptions.map((option) => (
                        <MotifOption key={option.value} value={option.value}>
                          {option.name}
                        </MotifOption>
                      ))}
                    </MotifSelect>
                  </MotifFormField>
                  <MotifButton
                    style={{ height: "45.5px" }}
                    onClick={handleExport}
                    disabled={!data || data.results.length === 0}
                    size="small"
                    type="submit"
                    variant={EXPORT_BUTTON_VARIANT}
                    loading={importLoading}
                  >
                    {t("global.globalActions.export")}
                  </MotifButton>
                </div>
              }
              title={headerData.title}
              description={headerData.description}
              components={[]}
              overlayNoRowsTemplate={
                isFetching
                  ? t(tableLoadingData)
                  : error
                  ? t("global.globalNotifications.wentWrong")
                  : t("global.globalNotifications.noRecords")
              }

              // pagination={true}
            />
            <CustomPagination
              apiData={data}
              apiStatus={status}
              currentpage={paginationObj.currentPage}
              pageSize={paginationObj.pageSize}
              disableNext={!data?.hasMoreRecords}
              onChangePageSize={(page: number) => {
                dispatch(
                  setComponentState1({
                    entityName: "importHistoryTabState",
                    entityState: {
                      importId: importJobId,
                      PageSize: page,
                      PageNumber: 1,
                    },
                  })
                );
              }}
              onChangeNextPage={() => {
                dispatch(
                  setComponentState1({
                    entityName: "importHistoryTabState",
                    entityState: {
                      importId: importJobId,
                      PageNumber: paginationObj.currentPage + 1,
                    },
                  })
                );
              }}
              onChangePreviousPage={() => {
                dispatch(
                  setComponentState1({
                    entityName: "importHistoryTabState",
                    entityState: {
                      importId: importJobId,
                      PageNumber: paginationObj.currentPage - 1,
                    },
                  })
                );
              }}
              pageSizeSelector={paginationPageSizeSelector}
            />
          </div>
        )}
      </div>
    </>
  );
}
